import { ITextFieldProps, Stack } from "@fluentui/react";
import React, { useState } from "react";
import { Control, Controller, FieldErrors } from "react-hook-form";

import { FormValidationRules } from "../../utils/types/FormValidationRules";
import { getValidate } from "../../utils/validation/getValidate";
import { FailureSeverity, ValidationFailure } from "../../utils/validation/ValidationResult";
import { FormErrorMessage } from "./FormErrorMessage";
import { FormFailureMessages } from "./FormFailureMessages";

export type FormAdditionalValidationProp = Pick<ITextFieldProps, "multiline"> & {
    name: string;
    control: Control;
    errors: FieldErrors;
    rules?: FormAdditionalValidationRules;
};

export const FormAdditionalValidation: React.FunctionComponent<FormAdditionalValidationProp> = (
    props: FormAdditionalValidationProp
) => {
    const [warnings, setWarnings] = useState<ValidationFailure[]>([]);

    const render = () => {
        return <Stack />;
    };

    return (
        <Stack>
            <Controller
                name={props.name}
                control={props.control}
                rules={{
                    ...props.rules,
                    validate: getValidate<void, FormAdditionalValidationRules>(
                        props.rules,
                        props.control.formStateRef.current.submitCount,
                        setWarnings
                    )
                }}
                render={render}
            />
            <FormErrorMessage name={props.name} errors={props.errors} />
            <FormFailureMessages failures={warnings} severity={FailureSeverity.Warning} />
        </Stack>
    );
};

export interface FormAdditionalValidationRules extends FormValidationRules<void> {
    min?: string | number;
    max?: string | number;
    maxLength?: string | number;
    minLength?: string | number;
    pattern?: RegExp;
}
